import { GeneratePdfBDL } from '../bdl/generate_pdf';

export const GeneratePdfServices = () => ({ ...GeneratePdfBDL() });
